import { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { GoogleOAuthProvider, GoogleLogin } from '@react-oauth/google';
import { Box, Typography, CircularProgress } from '@mui/material';
import axios from '../../components/axios';
import { datadogLogs } from '@datadog/browser-logs';

const PeloQAgentLoginPage = () => {
    const client_id = process.env.REACT_APP_CLIENT_ID;
    const navigate = useNavigate();
    const location = useLocation();
    const [checking, setChecking] = useState(true);

    const getRedirectUri = () => new URLSearchParams(location.search).get('redirect_uri');

    const redirectToCallback = (uri, email) => {
        window.location.href = `${process.env.REACT_APP_API_URL}/peloton/v1/peloqagent/auth/callback?redirect_uri=${encodeURIComponent(uri)}&email=${encodeURIComponent(email)}`;
    };

    useEffect(() => {
        const uri = getRedirectUri();
        const checkLogin = async () => {
            try {
                const response = await axios.post('/peloton/v1/users/auth-token', null, { withCredentials: true });
                if (response.data.message === 'success') {
                    if (uri) {
                        redirectToCallback(uri,response.data.email);
                    } else {
                        navigate('/');
                    }
                    return;
                }
            } catch (_) {
                // not logged in, fall through to show login UI
            }
            setChecking(false);
        };
        checkLogin();
    }, []); // eslint-disable-line react-hooks/exhaustive-deps

    const responseGoogle = (response) => {
        const idToken = response.credential;
        localStorage.setItem('gapi.tokenId', idToken);
        const uri = getRedirectUri();
        axios.post('/peloton/v1/users/role-permission', null, {
            headers: { 'Authorization': 'Bearer ' + idToken },
            withCredentials: true,
            timeout: 300000,
        })
        .then(res => {
            if (res.data.message === 'success') {
                localStorage.setItem('qbarn.user', JSON.stringify(res.data.user_info));
                if (process.env.REACT_APP_ENV.trim() === 'dev' || process.env.REACT_APP_ENV.trim() === 'stage') {
                    datadogLogs.logger.info('qbarn-frontend', { name: 'Login', id: res.data.user_info.uuid });
                }
                if (uri) {
                    redirectToCallback(uri, res.data.user_info.name);
                } else {
                    navigate('/');
                }
            } else {
                alert(res.data.message);
            }
        })
        .catch(err => {
            if (!err.response) {
                alert(err);
            } else {
                alert(err.response.data.message);
            }
        });
    };

    if (checking) {
        return (
            <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
                <CircularProgress />
            </Box>
        );
    }

    return (
        <Box sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', height: '100vh', gap: 3 }}>
            <Typography variant="h4" sx={{ color: '#406599', fontFamily: '"Roboto", "sans-serif"' }}>
                QBarn for PeloQAgent
            </Typography>
            <Typography variant="body1">
                Please sign in to continue
            </Typography>
            <GoogleOAuthProvider clientId={client_id}>
                <GoogleLogin
                    onSuccess={responseGoogle}
                    onError={() => alert('Google login failed')}
                    text="signin_with"
                    useOneTap
                />
            </GoogleOAuthProvider>
        </Box>
    );
};

export default PeloQAgentLoginPage;
